import { BaseSopOperation } from "./_Base";
import { InputCloneMode } from "../../../engine/poly/InputCloneMode";
import { isBooleanTrue } from "../../../core/BooleanValue";
export class ObjectPropertiesSopOperation extends BaseSopOperation {
  static type() {
    return "objectProperties";
  }
  cook(inputCoreGroups, params) {
    const coreGroup = inputCoreGroups[0];
    for (let object of coreGroup.objects()) {
      if (isBooleanTrue(params.applyToChildren)) {
        object.traverse((child) => {
          this._updateObject(child, params);
        });
      } else {
        this._updateObject(object, params);
      }
    }
    return coreGroup;
  }
  _updateObject(object, params) {
    if (isBooleanTrue(params.tname)) {
      object.name = params.name;
    }
    if (isBooleanTrue(params.trenderOrder)) {
      object.renderOrder = params.renderOrder;
    }
    if (isBooleanTrue(params.tfrustumCulled)) {
      object.frustumCulled = params.frustumCulled;
    }
    if (isBooleanTrue(params.tmatrixAutoUpdate)) {
      object.matrixAutoUpdate = params.matrixAutoUpdate;
    }
    if (isBooleanTrue(params.tvisible)) {
      object.visible = params.visible;
    }
    if (isBooleanTrue(params.tcastShadow)) {
      object.castShadow = params.castShadow;
    }
    if (isBooleanTrue(params.treceiveShadow)) {
      object.receiveShadow = params.receiveShadow;
    }
  }
}
ObjectPropertiesSopOperation.DEFAULT_PARAMS = {
  applyToChildren: false,
  tname: false,
  name: "",
  trenderOrder: false,
  renderOrder: 0,
  tfrustumCulled: false,
  frustumCulled: true,
  tmatrixAutoUpdate: false,
  matrixAutoUpdate: false,
  tvisible: false,
  visible: true,
  tcastShadow: false,
  castShadow: true,
  treceiveShadow: false,
  receiveShadow: true
};
ObjectPropertiesSopOperation.INPUT_CLONED_STATE = InputCloneMode.FROM_NODE;
